import '../Styles/Hero.css'

import React, { useEffect } from 'react';
import Typed from 'typed.js';

import Lottie from "lottie-react";
import devAnimation from "../animation/dev-2.json";

import { useRef } from "react";
import { motion } from "framer-motion";
import Header from './Header';
import Skills from './Skills';
import Contact from './Contact';


const Hero = () => {
  const lottieRef = useRef();
  useEffect(() => {
    // Options for Typed.js
    const options = {
      strings: ["Aabada Amine"],
      typeSpeed: 250,
      backSpeed: 250,
      loop: true,
    };

    // Initialize Typed.js
    const typed = new Typed(".auto-type", options);

    // Cleanup on component unmount
    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <>
      <Header />
      <section className="hero flex " id='hero'>
        <div className="left-section  ">

          {/* <div className="parent-avatar flex">
          <motion.img
            initial={{ transform: "scale(0)" }}
            animate={{ transform: "scale(1.1)" }}
            transition={{ damping: 6, type: "spring", stiffness: 100 }}
            src="./me.jpg"
            className="avatar"
            alt=""
          />
          <div className="icon-verified"></div>
        </div> */}

          {/* <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className="title"
        >
          Hi, I’m Aabada Amine,
          
        </motion.h1> */}
          <h4 className="F-sub-title">
            Hello, my name is
          </h4>
          <motion.div
            initial={{ opacity: 0, translateY: '-20px' }}
            animate={{ opacity: 1, translateY: 0 }}
            transition={{ duration: 3 }}

          >
            <h1 className="title">
              <span className="auto-type" id='typespan'>
              </span>
            </h1>
            <h1 >
              And I’m Web Developer
            </h1>
          </motion.div>

          <p className="sub-title">
            A passionate web developer skilled in both front-end and back-end technologies,
            I specialize in building dynamic and responsive websites.
            We are committed to staying at the forefront of technology to provide cutting-edge solutions.
          </p>

          <div className="all-icons flex">

            <div className="icon icon-twitter"></div>
            <a href="https://www.instagram.com/a_m_i_n_e__aa/">
              <div className="icon icon-instagram"></div>
            </a>
            <a href='https://github.com/AminEaabada?tab=repositories' >
              <div className="icon icon-github"></div>
            </a>
            {/* <div className="icon icon-linkedin"></div> */}
          </div>
        </div>

        <div className="right-section animation ">
          <Lottie style={{ height: '500px' }}
            lottieRef={lottieRef}
            className=""
            onLoadedImages={() => {
              // @ts-ignore
              // https://lottiereact.com/
              lottieRef.current.setSpeed(0.5);
            }}
            animationData={devAnimation}
          />
        </div>
      </section>
      <div className="divider" />
      <Skills />
      <div className="divider" />
      <Contact />
    </>
  );
};

export default Hero;
